import type { FC, ReactNode } from 'react';
import { Search } from 'lucide-react';
import { Input } from 'antd';
import { IpcFilterActions } from './IpcFilterActions';
import { IpcFilterChips, type IpcFilterChipItem } from './IpcFilterChips';
import { handleFilterTextBlur } from './ipcFilterTextCommit';

type Props = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSearchSubmit: () => void;
  /** 重置：恢复默认筛选 */
  onReset: () => void;
  children: ReactNode;
  /** 已应用筛选 chips（渲染在筛选行正下方） */
  chipItems?: IpcFilterChipItem[];
  onRemoveChip?: (key: string) => void;
  /** 清除全部：清空所有条件（与 onReset 不同） */
  onClearChips?: () => void;
};

/** Filter bar: search fields + query + reset + optional applied chips. */
export const IpcFilterBar: FC<Props> = ({
  searchValue,
  onSearchChange,
  onSearchSubmit,
  onReset,
  children,
  chipItems,
  onRemoveChip,
  onClearChips,
}) => (
  <div className="ipc-filter-section" onBlur={event => handleFilterTextBlur(event, onSearchSubmit)}>
    <div className="ipc-filter-bar">
      <Input
        allowClear
        prefix={<Search size={16} />}
        placeholder="搜索项目名称..."
        value={searchValue}
        onChange={e => onSearchChange(e.target.value)}
        onPressEnter={onSearchSubmit}
        className="ipc-filter-bar__search"
      />
      {children}
      <IpcFilterActions onReset={onReset} onSubmit={onSearchSubmit} />
    </div>
    {chipItems != null && onRemoveChip && onClearChips ? (
      <IpcFilterChips items={chipItems} onRemove={onRemoveChip} onClearAll={onClearChips} />
    ) : null}
  </div>
);
